import { get } from 'lodash'
import { useEffect, useRef, useCallback } from 'react'
import { ModalBody, ModalHeader, Button } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'

import { optionsSendLinkMethod } from './constants'
import { getInsured, getCitizenId } from 'e-submission/domain/data-model/form/selectors'
import { getCurrentApp } from '../../apps/selectors'
import { setSendLinkTextInput, setSendLinkMethod } from '../../apps/actions'
import createTextInput from '../../components/Form/Input/TextInput'
import { Modal } from '../../../common-components'
import { validateSendLinkInputPopup } from '../../domain/data-model/form/validation'

export const _EkycOnDevice = (props) => {
  const {
    insuredOrPayer,
    isOpen,
    openModal,
    onExit,
    options,
    setMethod,
    method,
    textInput,
    setTextInput,
    validateInput,
    citizenId,
    handlerCreateCaseEkyc,
  } = props

  const isInvalid = validateInput && !validateInput.isOk
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
      toggle={() => {
        onExit()
      }}
    >
      <ModalHeader
        toggle={() => {
          onExit()
        }}
      >
        ยืนยันตัวตนบนอุปกรณ์
      </ModalHeader>
      <ModalBody>ทดสอบ ยืนยันตัวตนบนอุปกรณ์</ModalBody>
    </Modal>
  )
}

const mapStateToSendEkycLinkPopup = (state) => {
  const app = getCurrentApp(state)
  const insuredInfo = getInsured(app)

  const insuredId = getCitizenId('insured')(app)
  const payerId = getCitizenId('payer')(app)

  const insuredEmail = get(insuredInfo, 'email', '')
  const insuredMobileNo = get(insuredInfo, 'mobileNumber', '')
  const textInput = get(app, ['ekycInfo', 'sendLink', 'textInput'], insuredMobileNo)
  const method = get(app, ['ekycInfo', 'sendLink', 'method'], 'sms')
  const validateInput = validateSendLinkInputPopup({ textInput }, method)

  return {
    insuredEmail,
    insuredMobileNo,
    textInput,
    method,
    validateInput,
    options: optionsSendLinkMethod,
    citizenId: { insured: insuredId, payer: payerId },
  }
}

const EkycOnDeviceContainer = (props) => {
  const { insuredOrPayer, isOpen, openModal, onExit, ...otherProps } = props

  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const selectorData = mapStateToSendEkycLinkPopup(state)

  const prevMethodRef = useRef()
  const prevIsOpenRef = useRef()

  const setTextInput = useCallback((e) => dispatch(setSendLinkTextInput('ekycInfo.sendLink.textInput', e)), [dispatch])

  const setMethod = useCallback((e) => dispatch(setSendLinkMethod('ekycInfo.sendLink.method', e)), [dispatch])

  // componentDidMount equivalent
  useEffect(() => {
    setTextInput(selectorData.insuredMobileNo)
  }, []) // Empty dependency array for mount only

  // componentDidUpdate equivalent
  useEffect(() => {
    if (selectorData.method !== prevMethodRef.current) {
      setTextInput(selectorData.method === 'sms' ? selectorData.insuredMobileNo : selectorData.insuredEmail)
      prevMethodRef.current = selectorData.method
    }
  }, [selectorData.method, selectorData.insuredMobileNo, selectorData.insuredEmail, setTextInput])

  // UNSAFE_componentWillReceiveProps equivalent
  useEffect(() => {
    if (!isOpen && isOpen !== prevIsOpenRef.current) {
      setMethod('sms')
    }
    prevIsOpenRef.current = isOpen
  }, [isOpen, setMethod])

  return (
    <_EkycOnDevice
      {...otherProps}
      insuredOrPayer={insuredOrPayer}
      isOpen={isOpen}
      openModal={openModal}
      onExit={onExit}
      setTextInput={setTextInput}
      setMethod={setMethod}
      {...selectorData}
    />
  )
}

export default EkycOnDeviceContainer
